




















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class HdrPatientDetailHeader extends Vue {
  @Prop()
  private patient: any;
  private goBack() {
    // this.$router.push("/main/idr/patient-list");
    this.$router.push({
      path: "/main/sjzx/zbsjk-list",
    });
  }
}
